// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"6f44295a","82":"c818885e","239":"3bf19e8e","291":"953b2db2","455":"f23467d0","501":"f7f1ecb8","977":"ce3776e3"}[chunkId] + ".chunk.js";
};